import { Glossary } from "../Glossary";
import { useLanguage } from "../../context/LanguageContext";
import { useHome } from "../../translations/home";
import { useCountUp } from "../../hooks/useCountUp";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import { DemoCTA } from "./DemoCTA";

const BigStat = ({ value, desc, source, delay, index }) => {
  const { ref, displayValue } = useCountUp(value, { duration: 2000, delay });
  return (
    <div ref={ref} className="relative" data-testid={`problem-stat-${index}`}>
      <p className="text-6xl sm:text-7xl lg:text-8xl font-extrabold text-white tracking-[-0.04em] tabular-nums mb-4 roi-glow-amber">
        <span className="stat-sweep">{displayValue}</span>
      </p>
      <p className="text-lg text-[#E4EEFC] leading-relaxed max-w-[26rem]">{desc}</p>
      <p className="mono-cayus text-[#5E6C83] mt-3">{source}</p>
    </div>
  );
};

const HomeProblem = () => {
  const { language } = useLanguage();
  const p = useHome(language).problem;
  const { ref, isRevealed } = useScrollReveal({ threshold: 0.2 });

  return (
    <section className="roi-dark-bg py-20 lg:py-24 relative overflow-hidden" data-testid="problem-section">
      <div className="absolute inset-0 dots-drift pointer-events-none opacity-70" aria-hidden="true" />
      <Glossary><div className="wrap-cayus relative">
        <div className="rule-cobalt mb-5 !bg-[linear-gradient(90deg,#5EB3F6_0%,#0047AB_100%)]" />
        <p className="mono-cayus text-[#5EB3F6] mb-4">{p.eyebrow}</p>
        <h2 className="font-bold text-3xl sm:text-4xl lg:text-[2.75rem] text-white tracking-[-0.03em] leading-[1.1] mb-14 max-w-[36ch]">
          {p.title}
        </h2>

        <div ref={ref} className={`grid md:grid-cols-2 gap-14 md:gap-10 mb-14 stagger-grid ${isRevealed ? "is-in" : ""}`}>
          {p.stats.map((s, i) => (
            <BigStat key={i} index={i} value={s.value} desc={s.desc} source={s.source} delay={i * 350} />
          ))}
        </div>

        <p className="text-xl text-[#CFE6FC] border-l-2 border-[#F59E0B] pl-6 mb-12 max-w-[46rem]" data-testid="problem-transition">
          {p.transition}
        </p>

        <DemoCTA from="problem" tone="dark" variant="ghost" />
      </div></Glossary>
    </section>
  );
};

export default HomeProblem;
